module.exports = "//static.hsappstatic.net/browser-eslint/static-1.7/eslint.js"